const Actions = {
  Form: {
    CHANGE: 'v.espe.actions.form.change'
  }
};

const Mutations = {
  INITIALIZE: 'v.espe.mutations.initialize',

  Form: {
    CHANGE: 'v.epse.mutations.form.change'
  }
};

export default {
  Actions,
  Mutations
};
